/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="搜索：">
        <el-input size="small" v-model="orderNumber" placeholder="输入订单号"></el-input>
      </el-form-item>
      <!-- <el-form-item>
        <el-select size="small" v-model="status" placeholder="请选择">
          <el-option v-for="type in payType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getOrderList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">

      
      <el-table-column sortable prop="orderNumber" label="订单号" width="210" show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="id" label="用户手机号" width="100">
      </el-table-column>
      <el-table-column prop="id" label="消耗积分" width="100">
      </el-table-column>



      <el-table-column prop="addTime" label="商品图" width="100">
        <template slot-scope="scope">
          <el-image style="width: 80px; height: 80px;border-radius: 10px;"
            :src="getMainImg(scope.row.skillData)"></el-image>
        </template>
      </el-table-column>
      <el-table-column sortable label="商品名称"  :fit="true" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ getClassName(scope.row.skillData) }}</div>
        </template>
      </el-table-column>
      
      <el-table-column sortable prop="status" label="订单状态" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">待付款</div>
          <div v-if="scope.row.status == 1">待接单</div>
          <div v-if="scope.row.status == 2">待收货</div>
          <div v-if="scope.row.status == 3">待服务</div>
          <div v-if="scope.row.status == 4">服务中</div>
          <div v-if="scope.row.status == 5">已完成</div>
          <div v-if="scope.row.status == 6">已取消</div>
        </template>

      </el-table-column>
      <el-table-column prop="id" label="核销店铺" width="100">
      </el-table-column>
      <el-table-column sortable prop="createTime" label="核销时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createTime" label="创建时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>

    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import { queryIntegralOrder, getOrderDetails, setOrderRefund, getClassifyList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
 
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },

      orderNumber:""
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    this.getOrderList(1)


  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    
    // 获取订单列表
    getOrderList(page) {
      this.loading = true;
      var parameter = {
        key: this.orderNumber,
        page: (page - 1) * 20,
      };
      queryIntegralOrder(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          console.log('res.data.list', res.data)
          this.listData = res.data.orderBasicEntities
    


          this.pageparm.currentPage = page
          this.pageparm.total = res.data.count
 
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },
    
    // 分页插件事件
    callFather(parm) {
      // this.formInline.page = parm.currentPage
      // this.formInline.limit = parm.pageSize
      this.getOrderList(parm.currentPage)
    },
    // 搜索事件
    search() {
      this.getOrderList(1)
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      this.orderInfo = row;
      this.getOrderDetails()
    },

   
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/Order.vue